import { useState, useEffect } from "react";
import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { useEventsStore } from "@/store/events/events.store";
import { Events } from "@/models/database/event/Events.model";

const useSingleEvent = (slug: string) => {
  const [eventItem, setEventItem] = useState<Events | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);
  const eventStore = useEventsStore();

  useEffect(() => {
    const fetchEventItem = async () => {
      try {
        const storedEventItem = eventStore.getEventsBySlug(slug);
        if (storedEventItem) {
          setEventItem(storedEventItem);
          setLoading(false);
          return;
        }

        const querySnapshot = await collectionRef
          .events(brand.tenantId)
          .where("slug", "==", slug)
          .limit(1)
          .get();

        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];

          setEventItem({
            ...doc.data(),
          } as Events);
        } else {
          setError(Error("No news item found with the given slug"));
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEventItem();
  }, [slug]);

  return { eventItem, loading, error };
};

export default useSingleEvent;
